import { render, staticRenderFns } from "./alarmType.vue?vue&type=template&id=80616420&scoped=true"
import script from "./alarmType.vue?vue&type=script&lang=js"
export * from "./alarmType.vue?vue&type=script&lang=js"
import style0 from "./alarmType.vue?vue&type=style&index=0&id=80616420&prod&scoped=true&lang=scss"
import style1 from "./alarmType.vue?vue&type=style&index=1&id=80616420&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80616420",
  null
  
)

export default component.exports